var site = site || {};
var generic = generic || {};
site.userInfoCookie = site.userInfoCookie || {};
site.userInfoCookie.getValue =
  site.userInfoCookie.getValue ||
  function () {
    return '';
  };
var loyaltySetting = Drupal.settings.loyalty || {};
(function ($) {
  Drupal.behaviors.loyaltyJoinSigninV1 = {
    attach: function (context) {
      var params;
      var is_sign_in = 0;
      var is_loyalty = 0;
      var $allPanels,
        $defaultPanel,
        self,
        target,
        $toggleAccordion,
        $caretIcon,
        $accordionIcon,
        email = '';
      var isMobile = site.client.isMobile;
      var container = $('.marketing_page_wrapper', context);
      var is_loyalty_member = site.userInfoCookie.getValue('is_loyalty_member');
      var rendered = '';

      $(document).on('user.loaded', function (event, val) {
        if (!val.is_pro) {
          if (val.signed_in) {
            email = val.email_address;
            is_sign_in = 1;
            if (is_loyalty_member === '1') {
              is_loyalty = 1;
            }
          }
          var isOfferPage = $('.loyalty__offers__wrapper').length ? 1 : 0;

          params = {
            sign_in: is_sign_in,
            loyalty: is_loyalty,
            email: email,
            is_offer_page: isOfferPage
          };
          var $LoyaltyUserModule;
          if (loyaltySetting.lr2021 && is_sign_in && is_loyalty) {
            var $LoyaltySignupModule = $(
              '.marketing__wrapper--redesign2021 .js-enrollment-module',
              context
            );
            var updateUserModule = function () {
              var paramObj = {};
              if ($.cookie('csrftoken')) {
                paramObj._TOKEN = $.cookie('csrftoken');
              }
              $LoyaltyUserModule.addClass('is-updating');
              generic.jsonrpc.fetch({
                method: 'loyalty.user.get',
                params: [paramObj],
                onSuccess: function (response) {
                  if (typeof response.getValue().loyalty_level_next !== 'undefined') {
                    params.userCookie.points_to_next_level = response.getValue().loyalty_level_next.needs.points_min;
                    if (params.userCookie.points_to_next_level > 0) {
                      $('.js-max-tier', $LoyaltyUserModule).hide();
                      $('.js-next-tier', $LoyaltyUserModule)
                        .removeClass('hidden')
                        .find('.loyalty__panel__points__points-number')
                        .html(params.userCookie.points_to_next_level);
                    }
                  }
                  $LoyaltyUserModule.removeClass('is-updating');
                }
              });
            };
            $LoyaltyUserModule = $('.marketing__wrapper--redesign2021 .js-user-status', context);
            $LoyaltySignupModule.hide();
            params.userCookie = {};
            var userCookieFields = [
              'anniversary_date',
              'current_available',
              'is_loyalty_member',
              'loyalty_level',
              'loyalty_level_name',
              'next_level',
              'next_level_name',
              'points_to_next_level'
            ];
            $.each(userCookieFields, function (index, value) {
              params.userCookie[value] = site.userInfoCookie.getValue(value);
            });
            if (
              params.userCookie.next_level !== null &&
              params.userCookie.points_to_next_level === null
            ) {
              // if for some reason userCookie does not have needed values, lets try to fetch them and update user module content (LOYAL-9774)
              updateUserModule();
            }
            if (params.userCookie.points_to_next_level > 0) {
              $('.js-max-tier', $LoyaltyUserModule).hide();
              $('.js-next-tier', $LoyaltyUserModule).removeClass('hidden');
            }
            if (
              loyaltySetting.lr2021 &&
              loyaltySetting.lr2021_user_status_layout_dynamic &&
              !site.client.isMobile
            ) {
              setTimeout(function () {
                var $info_sections = $('.user_status-info_section', context);

                $(window).on(
                  'resize',
                  _.debounce(function () {
                    $($info_sections).matchHeight({ remove: true }).matchHeight();
                  }, 300)
                );

                $($info_sections).matchHeight();
              }, 500);
            }
          }
          rendered = site.template.render(container.html(), params);
          $('.loyalty_join_signin_wrapper', context).html(rendered);
          if (loyaltySetting.lr2021 && is_sign_in && is_loyalty) {
            // lets update background images for loyalty status and banner panels, this must be done after mustache render and context update
            var $MarketingBanner = $(
              '.marketing__wrapper--redesign2021 .js-marketing-banner',
              context
            );
            $LoyaltyUserModule = $('.marketing__wrapper--redesign2021 .js-user-status', context);
            var MarketingBannerBgDataUrl = $MarketingBanner.data(
              'bg-img-tier-' + params.userCookie.loyalty_level
            );
            var LoyaltyUserModuleBgDataUrl = $LoyaltyUserModule.data(
              'bg-img-tier-' + params.userCookie.loyalty_level
            );
            if ($MarketingBanner && MarketingBannerBgDataUrl) {
              $MarketingBanner.css('background-image', 'url(' + MarketingBannerBgDataUrl + ')');
            }
            if ($LoyaltyUserModule && LoyaltyUserModuleBgDataUrl) {
              $LoyaltyUserModule.css('background-image', 'url(' + LoyaltyUserModuleBgDataUrl + ')');
            }
          }
          if (isMobile) {
            $allPanels = $('.js-panel', context);
            $allPanels.hide();
            $accordionIcon = $('.accordion .icon', context);
            $defaultPanel = $('.marketing__benefits__section__content .js-panel', context);
            $defaultPanel.addClass('active').slideDown();
            $toggleAccordion = $('.js-accordion');
            $toggleAccordion.click(function () {
              self = $(this);
              $caretIcon = self.find('.icon', context);
              target = self.closest('.js-accordion').next();
              target.toggleClass('active');
              $accordionIcon.removeClass('icon-arrow_up').addClass('icon-arrow_down');
              if (!target.hasClass('active')) {
                $allPanels.removeClass('active').slideUp();
                $caretIcon.removeClass('icon-arrow_up').addClass('icon-arrow_down');
              } else {
                $allPanels.removeClass('active').slideUp();
                target.addClass('active').slideDown();
                $caretIcon.removeClass('icon-arrow_down').addClass('icon-arrow_up');
              }
            });
          }
          var $SMScommunicationChk = $('.js-marketing__enrollment__accept__sms_promotions');
          var $SMScommunicationInp = $('.js-marketing__enrollment__phone_number');

          if ($SMScommunicationChk.length > 0) {
            $SMScommunicationChk.on('change', function () {
              if ($SMScommunicationChk.prop('checked')) {
                $SMScommunicationInp.removeClass('hidden');
              } else {
                $SMScommunicationInp.addClass('hidden');
              }
            });
          }
        }
      });
    }
  };
})(jQuery);
